import styled from "styled-components/macro";

export const GridContainer = styled.div`
  width: 90%;
  margin: 0 auto;
  .ant-carousel .slick-prev,
  .ant-carousel .slick-next,
  .ant-carousel .slick-prev:hover,
  .ant-carousel .slick-next:hover {
    font-size: inherit;
    color: currentColor;
  }
  position: relative;

  @media (max-width: 1000px) {
    max-width: 800px;
  }

  @media (max-width: 768px) {
    max-width: ${(props) => props.theme.sizes.maxWidthContainer};
  }

  @media (max-width: 570px) {
    max-width: 500px;
  }

  @media (max-width: 450px) {
    width: 100%;
    max-width: 100vw;
  }

  @media (max-width: 375px) {
    width: 100%;
    max-width: 100vw;
  }
`;

export const Arrow = styled.div`
  position: absolute;
  z-index: 30;
  width: 20px;
  height: 20px;
  border-left: 2px solid #032565;
  border-top: 2px solid #032565;
  bottom: calc(50% - 10px);
  cursor: pointer;
  @media ${(props) => props.theme.media.phone} {
    display: none;
  }
`;

export const PhotoPlaceholderContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 220px;
`;

export const PhotoPlaceholder = styled.div`
  background: ${({ theme }) => theme.colors.bgSoftGray};
  width: 220px;
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  @media ${(props) => props.theme.media.tablet} {
    width: 50%;
  }

  @media ${(props) => props.theme.media.phone} {
    width: 95%;
  }
`;
